import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { IAutoplayOptions } from "../store/interfaces";
import { RoundRepository } from "../round.repository";

@Injectable()
export class SetAutoplayUseCase implements IUseCase<IAutoplayOptions, void> {
    constructor(private roundRepository: RoundRepository) {}

    execute(data: IAutoplayOptions): void {
        this.roundRepository.setAutoplayOptions(data);
    }
}
